import styled from 'styled-components';

export const Container = styled.section`
  margin: 0 auto;
  margin-top: 60px;

  max-width: 1200px;

  @media(max-width: 1200px){
    margin-top: 72px;
  }

  h3 {
    font-family: Gilroy Light;
    font-size: 24px;
    margin: 24px 0;
    margin-left: 24px;
  }

  .scrollContainer {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
  }
`;
